export default "<iframe class=\"full\" src=\"https://app.termly.io/document/cookie-policy/00c0aa21-7b1b-4322-9f1a-fbe1179fc28d\"\r\n    ></iframe>"